import styled from "styled-components";

export const FormItemWrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;
`;
export const Label = styled.p`
  font-weight: bold;
`;
